import { z } from 'zod';

export const SMS_KEYWORDS = ['stop', 'help', 'start'] as const;
export const SmsKeywordSchema = z.enum(SMS_KEYWORDS);
export type SmsKeyword = z.infer<typeof SmsKeywordSchema>;

const KEYWORD_WORDS = new Map<string, SmsKeyword>([
  ['stop', 'stop'],
  ['stopall', 'stop'],
  ['unsubscribe', 'stop'],
  ['cancel', 'stop'],
  ['end', 'stop'],
  ['quit', 'stop'],
  ['help', 'help'],
  ['info', 'help'],
  ['start', 'start'],
  ['unstop', 'start'],
]);

export function smsKeyword(text: string): SmsKeyword | null {
  const word = text
    .trim()
    .toLowerCase()
    .replace(/[^a-z]/g, '');
  return KEYWORD_WORDS.get(word) ?? null;
}

export function smsOptedOut(keywords: readonly SmsKeyword[]): boolean {
  return keywords.findLast((keyword) => keyword !== 'help') === 'stop';
}

export const SMS_STOP_NOTE =
  'This member texted STOP, so Klaviyo will not deliver texts. Email them instead.';

export const SMS_MAX_CHARS = 1600;

export function smsReplyRefusal(text: string, keywords: readonly SmsKeyword[]): string | null {
  if (smsOptedOut(keywords)) {
    return SMS_STOP_NOTE;
  }
  if (text.length > SMS_MAX_CHARS) {
    return `Texts are limited to ${SMS_MAX_CHARS} characters.`;
  }
  return null;
}
